export default function (target, regex) {
  const { value } = target;
  const re = new RegExp(`[^a-zA-Zа-яА-ЯёЁієїЄІЇ\b${regex}\b]`, 'g');
  target.value = value.replace(re, '');
}
